import logo from "./logo.svg";
import "./App.css";
import { Container } from "@mui/material";
import Dashboard from "./pages/dashboard/index";
function App() {
  return (
    <>
      <Dashboard />
    </>
  );
}

export default App;
